<template>
  <div class="form-section mt-4 mb-2" v-if="superUser">

    <!-- Container for title and button -->
    <div class="mt-4 d-flex align-items-between justify-content-between">
      <!-- Title -->
    <h5 style="font-weight: bolder; color: #555555" class="ms-5">Καταχωρημένοι Χρήστες</h5>

      <!-- Add Button -->
      <button v-if="!showForm" class="btn btn-primary fw-bold" style="margin-left:10px;" @click="showAddForm">ΠΡΟΣΘΗΚΗ
        +</button>
    </div>

    <!-- Form Container -->
    <div v-if="showForm" class="form-container ms-5 col-md-10">
      <!-- Form Fields -->
      <div class="row" style="color:#4A4A4A; font-weight:bolder">
        <!-- Left Column -->
        <div class="col-md-4">
          <p class="label-with-circle2"><strong>Name</strong>
            <hr />
          </p>
          <input type="text" v-model="form.name" class="form-control" maxlength="255" required />
        </div>
        <div class="col-md-4">
          <p class="label-with-circle2"><strong>Surname</strong>
            <hr />
          </p>
          <input type="text" v-model="form.surname" class="form-control" maxlength="255" required />
        </div>
        <div class="col-md-4">
          <p class="label-with-circle2"><strong>Email</strong>
            <hr />
          </p>
          <input type="text" v-model="form.email" class="form-control" maxlength="255" required />
        </div>
        <div class="col-md-4 mt-3 form-group">
          <p class="label-with-circle2"><strong>Tel</strong>
            <hr />
          </p>
          <input type="text" v-model="form.tel" class="form-control" /><br />

         
        </div>
        <div class="col-md-4 mt-3">
          <p class="label-with-circle2"><strong>Password</strong>
            <hr />
          </p>
          <input type="password" v-model="form.password" class="form-control" maxlength="255" required />
        </div>
        <div class="col-md-4 mt-3">
          <p class="label-with-circle2"><strong>Confirm Password</strong>
            <hr />
          </p>
          <input type="password" v-model="form.confirmPassword" class="form-control" maxlength="255" required />
        </div>
        <div class="col-md-4">
          <p class="label-with-circle2"><strong>User roles</strong>
            <hr />
          </p>
          <Select2 v-model="form.role_ids" :options="roles" :settings="select2Settings"
            :multiple="true" :placeholder="'Select roles'" class="form-control" />
        </div>

        <!-- Middle Column -->
        
      </div>

      <!-- Form Actions -->
      <div class="row form-actions mt-1">
        <div class="d-flex justify-content-end">
          <button class="btn btn-secondary" @click="resetForm">ΑΚΥΡΩΣΗ</button>
          <button class="btn btn-primary ms-2 save-button" @click="openSaveModal">ΑΠΟΘΗΚΕΥΣΗ</button>
        </div>
      </div>
    </div>

    <!-- Display list of rooms -->
    <div class="mt-2 row ms-2" style="width:100%">
      <div v-for="(user, index) in users" :key="user.id" class="room-item col-md-5 me-3 ms-3">
        <div class="card shadow-custom form-container mb-3 bg-white rounded position-relative">
          <!-- Non-Editable View -->
          <div v-if="!user.isEditing " >
            <div class="row" style="color:#A6A6A6; font-weight:bolder">
              <!-- Left Column -->
              <div class="col-md-6">
                <p class="label-with-circle"><strong>Name</strong>
                  <hr />
                </p>
                <p>{{ user.name }}</p>
              </div>
              <div class="col-md-6">
                <p class="label-with-circle"><strong>Surname</strong>
                  <hr />
                </p>
                <p>{{ user.surname }}</p>
              </div>
              <div class="col-md-6 mt-3">
                <p class="label-with-circle"><strong>Email</strong>
                  <hr />
                </p>
                <p>{{ user.email }}</p>
              </div>
              <div class="col-md-6 mt-3">
                <p class="label-with-circle"><strong>Tel</strong>
                  <hr />
                </p>
                <p>{{ user.tel }}</p>
              </div>
              <div class="col-md-8 mt-3">
                <p class="label-with-circle"><strong>User Roles</strong>
                  <hr />
                </p>
                <p>{{ user.roleNames }}</p>
              </div>
            </div>

            <!-- Edit Button -->
            <div class="action-buttons">
              <button class="btn border-0 p-1 edit" @click="editUser(index)">
                <img src="../assets/images/edit-budget.png" alt="Edit" width="30">
              </button>
            </div>
          </div>

          <!-- Editable View -->
          <div v-else>
            <div class="row" style="color:#4A4A4A; font-weight:bolder">
              <!-- Left Column -->
              <div class="col-md-6">
                <p class="label-with-circle2"><strong>Name</strong>
                  <hr />
                </p>
                <input type="text" v-model="form.name" class="form-control" maxlength="255" required />
              </div>
              <div class="col-md-6">
                <p class="label-with-circle2"><strong>Surname</strong>
                  <hr />
                </p>
                <input type="text" v-model="form.surname" class="form-control" maxlength="255" required />
              </div>
              <div class="col-md-6 mt-3">
                <p class="label-with-circle2"><strong>Email</strong>
                  <hr />
                </p>
                <input type="text" v-model="form.email" class="form-control" maxlength="255" required />
              </div>
               <!-- Middle Column -->
               <div class="col-md-6 mt-3 form-group">
                <p class="label-with-circle2"><strong>Tel</strong>
                  <hr />
                </p>
                <input type="text" v-model="form.tel" class="form-control" /><br />
</div>
<div class="col-md-8 mt-1">
                <p class="label-with-circle2"><strong>User Roles</strong>
                  <hr />
                </p>
                <Select2 v-model="form.role_ids" :options="roles" :settings="select2Settings"
                :multiple="true" :placeholder="'Select roles'" class="form-control" />
              </div>
             <!--  <div class="col-md-6 mt-3">
                <p class="label-with-circle2"><strong>Password</strong>
                  <hr />
                </p>
                <input type="password" v-model="form.password" class="form-control" maxlength="255" required />
              </div>
              <div class="col-md-6 mt-3">
                <p class="label-with-circle2"><strong>Confirm Password</strong>
                  <hr />
                </p>
                <input type="password" v-model="form.confirmPassword" class="form-control" maxlength="255" required />
              </div> -->
             
            </div>

            <div class="row form-actions">
              <div class="d-flex justify-content-end">
                <button class="btn btn-secondary justify-content-end align-items-end"
                  @click="cancelEdit(index)">ΑΚΥΡΩΣΗ</button>
              </div>
            </div>

            <!-- Form Actions -->
            <div class="action-buttons mt-5">
              <button class="btn border-0 p-1 mb-2 save mt-3" @click="openEditModal(index)">
                <img src="../assets/images/save.png" alt="Save" width="30">
              </button>
              <button class="mt-5 btn border-0 p-1 delete" @click="openDeleteModal(index)">
                <img src="../assets/images/bin.png" alt="Delete" width="30">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Save Confirmation Modal -->
    <div class="modal fade" id="saveModal" tabindex="-1" aria-labelledby="saveModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="saveModalLabel">Επιβεβαίωση Αποθήκευσης</h5>
            <button type="button" class="close" @click="closeSaveModal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Είστε σίγουροι ότι θέλετε να αποθηκεύσετε το δωμάτιο;
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeSaveModal">Ακύρωση</button>
            <button type="button" class="btn btn-primary" @click="confirmSaveUser">Αποθήκευση</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Confirmation Modal -->
    <div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModalLabel">Επιβεβαίωση Επεξεργασίας</h5>
            <button type="button" class="close" @click="closeEditModal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Είστε σίγουροι ότι θέλετε να αποθηκεύσετε τις αλλαγές;
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeEditModal">Ακύρωση</button>
            <button type="button" class="btn btn-primary" @click="confirmSaveUserEdit">Αποθήκευση</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Επιβεβαίωση Διαγραφής</h5>
            <button type="button" class="close" @click="closeDeleteModal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το χρήστη;
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDeleteModal">Ακύρωση</button>
            <button type="button" class="btn btn-danger" @click="confirmDeleteUser">Διαγραφή</button>
          </div>
        </div>
      </div>
    </div>



    <div class="modal fade" id="deleteSeasonModal" tabindex="-1" aria-labelledby="deleteSeasonModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteSeasonModalLabel">Επιβεβαίωση Διαγραφής</h5>
            <button type="button" class="close" @click="closeDeleteSeasonModal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη σεζόν;
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDeleteSeasonModal">Ακύρωση</button>
            <button type="button" class="btn btn-danger" @click="confirmDeleteSeason">Διαγραφή</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { useHead } from '@vueuse/head';
import { useToast } from 'vue-toastification';
import { createRoomType, getRoomTypes, updateRoomType, deleteRoomType } from '@/services/room-types';
import { getBudget, updateBudget, updateSupplement, updateSpa } from "@/services/budget";
import { getSeason, createSeason, deleteSeason } from '@/services/seasons';
import Select2 from "vue3-select2-component";
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import { createUser, deleteUser, getAllUsers, getRoles, updateUser } from '@/services/users';


export default {
  components: {
    Select2,
  },
  methods: {

    ...mapActions(['fetchUserData']),

  },
  computed: {
    ...mapGetters({
      getUserPermission: 'getUserPermission',
      getSuperUserPermission: 'getSuperUserPermission',
      getUserRoles: 'getUserRoles'

    }),
    superUser() {
      return this.getSuperUserPermission === 1;
    },
    canViewSales() {
      return this.getUserRoles.includes(1);
    },
    canViewFnB() {
      return this.getUserRoles.includes(2);
    },
    canViewHR() {
      return this.getUserRoles.includes(3);
    },
    canViewOperational() {
      return this.getUserRoles.includes(4);
    },

  },
  data() {
    return {
      seasons: [],
      roles: [],
      totalSeason: 0,
      totalSeasonHigh: 0,
      totalSeasonLow: 0,
      totalSeasonMiddle: 0,
      showForm: false,
      select2Settings: { multiple: true },

      form: {
        name: '',
        surname: '',
        email: '',
        password: '',
        confirmPassword: '',
        tel: '',
        role_ids: [],
      },
      users: [],
      boardType: '', // Single value for board type

      supplements: [], // Current supplements array
      boardTypesOptions: [
        { id: 'BB', text: 'BB' },
        { id: 'HB', text: 'HB' },
        { id: 'FB', text: 'FB' },
        { id: 'AI', text: 'AI' },
      ],
      supplementsOptions: [
        { id: 'HB', text: 'HB' },
        { id: 'FB', text: 'FB' },
        { id: 'AI', text: 'AI' },
      ],
      editableBoardType: '',
      editableSupplements: [], // Editable version for multi-select
      isEditingBoardTypes: false,
      isEditingSupplements: false,

      hasSpa: '',
      editableSpa: '', // Holds the editable value (1 or 0)
      editableSpaOperation: '', // Holds the editable value (1 or 0)
      single_cabins: 0,
      double_cabins: 0,
      beds: 0,
      isEditingSpa: false,

      currentDeleteIndex: null,

    };
  },
  methods: {
    // Fetch room types
    async fetchUsers() {
      try {
        const response = await getAllUsers();
        this.users = response.data.data.map((user) => ({ ...user, isEditing: false }));
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },
    async fetchRoles() {
      try {
        const response = await getRoles();
        const roles = response.data.data;
        let tmpRoles = [];
        for (let i = 0; i < roles.length; i++) {
          tmpRoles.push({id: roles[i].id, text: roles[i].title});
        }
        this.roles = tmpRoles;
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },

    async fetchSeasons() {
      try {
        const response = await getSeason(this.$route.params.budget_id);
        if (response.success) {
          this.seasons = response.data.map(season => ({
            ...season,
            isEditing: false
          }));
        }
      } catch (error) {
        console.error('Error fetching seasons:', error);
      }
    },

    addSeason() {
      // Get the last season's `season_date_to` value
      const lastSeason = this.seasons[this.seasons.length - 1];
      let nextSeasonStartDate = '';

      if (lastSeason && lastSeason.season_date_to) {
        // Calculate the next day after the last season's `season_date_to`
        const lastSeasonDateTo = new Date(lastSeason.season_date_to);
        nextSeasonStartDate = new Date(lastSeasonDateTo);
        nextSeasonStartDate.setDate(lastSeasonDateTo.getDate() + 1); // Add one day
        nextSeasonStartDate = nextSeasonStartDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
      }

      // Add a new season with the calculated `season_date_from`
      this.seasons.push({
        season_date_from: nextSeasonStartDate || '', // Use the calculated date or leave empty
        season_date_to: '', // Keep empty as it's yet to be set
        season_type: 'Middle', // Default season type
        isEditing: true // Set as editable
      });
    },


    editSeason(index) {
      this.seasons[index].isEditing = true;
    },
    async confirmDeleteSeason() {
      try {
        if (this.currentDeleteIndex !== null) {
          await this.deleteSeason(this.currentDeleteIndex); // Use the correct currentDeleteIndex
          this.saveAllSeasons(); // Save the remaining seasons
          $('#deleteSeasonModal').modal('hide');

        }
      } catch (error) {
        console.error('Error deleting room:', error);
      } finally {
        this.closeDeleteModal(); // Always close the modal
      }
    },

    async saveAllSeasons() {
      const response = await createSeason(this.$route.params.budget_id, { seasons: this.seasons });
      if (response.success) {
        this.fetchSeasons();
        this.calcSeasonDays();
        useToast().success(response.message);
      } else {
        useToast().error(response.message);
      }
    },

    cancelEditSeason(index) {
      this.seasons[index].isEditing = false;
      this.fetchSeasons();
    },

    async deleteSeason(index) {
      const season = this.seasons[index];
      console.log(season);
      if (season.id) {
        try {
          await deleteSeason(season.id); // Make API call to delete season by ID
          this.seasons.splice(index, 1);
        } catch (error) {
          console.error('Error deleting season:', error);
        }
      } else {
        this.seasons.splice(index, 1); // If no ID, just remove from local array
      }
    },
    async calcSeasonDays() {
      const response = await getBudget(this.$route.params.budget_id);
      if (response.data) {
        this.totalSeason = response.data.data.total_season;
        this.totalSeasonHigh = response.data.data.total_season_high;
        this.totalSeasonLow = response.data.data.total_season_low;
        this.totalSeasonMiddle = response.data.data.total_season_middle;
      }
    },

    showAddForm() {
      this.resetForm();
      this.showForm = true;
    },

    resetForm() {
      this.form = {
        name: '',
        surname: '',
        email: '',
        password: '',
        confirmPassword: '',
        tel: '',
        role_ids: []
      };
      this.showForm = false;
    },

    openSaveModal() {
      $('#saveModal').modal('show');
    },
    closeSaveModal() {
      $('#saveModal').modal('hide');
    },

    async confirmSaveUser() {
      try {
        const response = await createUser({
          name: this.form.name,
          surname: this.form.surname,
          email: this.form.email,
          password: this.form.password,
          confirmPassword: this.form.confirmPassword,
          tel: this.form.tel,
          role_ids: this.form.role_ids
        });
        if (response.data.success) {
          useToast().success(response.data.message);
        } else {
          useToast().error(response.data.message);
        }
        this.resetForm();
        this.closeSaveModal();
        this.fetchUsers();
      } catch (error) {
        console.error('Error saving user:', error);
      }
    },

    editUser(index) {
      const user = this.users.find((user) => user.isEditing);
      if (user) {
        user.isEditing = false;
      }
      this.users[index].isEditing = true;
      this.form = {...this.users[index]};
    },

    openEditModal(index) {
      $('#editModal').modal('show');
    },
    closeEditModal() {
      $('#editModal').modal('hide');
    },

    async fetchBudget() {
      try {
        const response = await getBudget(this.$route.params.budget_id);
        this.supplements = response.data.data.supplements || [];
        console.log(response.data)
      } catch (error) {
        console.error('Error fetching budget data:', error);
      }
    },

    async confirmSaveUserEdit() {
      try {
        const user = this.users.find((user) => user.isEditing);
        const response = await updateUser(user.id, {
          name: this.form.name,
          surname: this.form.surname,
          email: this.form.email,
          password: this.form.password,
          confirmPassword: this.form.confirmPassword,
          tel: this.form.tel,
          role_ids: this.form.role_ids
        });
        if (response.data.success) {
          useToast().success(response.data.message);
        } else {
          useToast().error(response.data.message);
        }
        this.fetchUsers();
        user.isEditing = false;
        this.closeEditModal();
      } catch (error) {
        console.error('Error updating room:', error);
      }
    },

    cancelEdit(index) {
      this.users[index].isEditing = false;
    },



    openDeleteModal(index) {
      this.currentDeleteIndex = index;
      $('#deleteModal').modal('show');
    },

    openDeleteSeasonModal(index) {
      this.currentDeleteIndex = index;
      $('#deleteSeasonModal').modal('show');
    },
    closeDeleteModal() {
      $('#deleteModal').modal('hide');
    },

    closeDeleteSeasonModal() {
      $('#deleteSeasonModal').modal('hide');
    },

    async confirmDeleteUser() {
      try {
        const user = this.users[this.currentDeleteIndex];
        const response = await deleteUser(user.id);
        if (response.data.success) {
          useToast().success(response.data.message);
        } else {
          useToast().error(response.data.message);
        }
        this.users.splice(this.currentDeleteIndex, 1);
        this.closeDeleteModal();
      } catch (error) {
        console.error('Error deleting room:', error);
      }
    },

    // Edit and save methods for board types
    editBoardTypes() {
      this.editableBoardType = this.boardType; // Set to current value
      this.isEditingBoardTypes = true;
    },
    // Enter editing mode and pre-select the current value
    editSpa() {
      this.editableSpa = this.hasSpa === "NAI" ? "1" : "0";
      this.editableSpaOperation = this.spa_operation_id;
      this.isEditingSpa = true;
    },
    // Cancel editing mode
    cancelEditSpa() {
      this.isEditingSpa = false;
    },
    // Save the updated SPA value
    async saveSpa() {
      try {
        await updateSpa(this.$route.params.budget_id, { hasSpa: this.editableSpa, spa_operation_id: this.editableSpaOperation, single_cabins: this.single_cabins, double_cabins: this.double_cabins, beds: this.beds });
        this.hasSpa = this.editableSpa === "1" ? "NAI" : "ΟΧΙ"; // Update display value
        this.spa_operation_id = this.editableSpaOperation;
        this.isEditingSpa = false; // Exit editing mode
        useToast().success("Επιτυχής καταχώρηση!!!");
        this.fetchSeasons();
        this.fetchRoomTypes();
        this.calcSeasonDays();
        this.populateBoardAndSupplement();
        this.fetchBudget();
      } catch (error) {
        console.error("Error updating SPA:", error);
        useToast().error("Failed to update Spa value.");
      }
    },
    saveBoardTypes() {
      this.boardType = this.editableBoardType; // Store as a single value
      updateBudget(this.$route.params.budget_id, { supplement: this.supplement, basic_board: this.editableBoardType });
      this.isEditingBoardTypes = false;
      useToast().success('Eπιτυχής καταχώρηση!!!');
    },
    cancelEditBoardTypes() {
      this.isEditingBoardTypes = false;
    },

    async editSupplements() {
      try {
        // Fetch budget data and populate current supplements
        const response = await getBudget(this.$route.params.budget_id);
        this.supplements = response.data.data.supplements;

        // Initialize editable supplements
        this.editableSupplements = [...this.supplements];

        this.isEditingSupplements = true;
      } catch (error) {
        console.error("Error fetching budget data:", error);
      }
    },
    saveSupplements() {
      // Update the supplements array and send to the API
      this.supplements = [...this.editableSupplements];

      updateSupplement(this.$route.params.budget_id, { supplements: this.supplements })
        .then(() => {
          useToast().success("Eπιτυχής καταχώρηση!!!");
        })
        .catch((error) => {
          console.error("Error updating supplements:", error);
        });

      this.isEditingSupplements = false;
    },
    cancelEditSupplements() {
      this.isEditingSupplements = false;
    },

    // Function to populate both basic board and supplement
    async populateBoardAndSupplement() {
      const r = await getBudget(this.$route.params.budget_id);
      if (r.data.data.basic_board) {
        this.boardType = r.data.data.basic_board;
        this.hasSpa = r.data.data.hasSpa == 1 ? "NAI" : "ΟΧΙ"; // Converts 1 to "NAI" and 0 to "ΟΧΙ"
        this.spa_operation_id = r.data.data.spa_operation_id; // Converts 1 to "NAI" and 0 to "ΟΧΙ"
        this.spa_operation = r.data.data.spa_operation; // Converts 1 to "NAI" and 0 to "ΟΧΙ"
        this.single_cabins = r.data.data.single_cabins; // Converts 1 to "NAI" and 0 to "ΟΧΙ"
        this.double_cabins = r.data.data.double_cabins; // Converts 1 to "NAI" and 0 to "ΟΧΙ"
        this.beds = r.data.data.beds; // Converts 1 to "NAI" and 0 to "ΟΧΙ"

      }
      if (r.data.data.supplement) {
        this.supplement = r.data.data.supplement;
      }
    }
  },
  mounted() {
    useHead({
      title: 'Τύποι Δωματίων',
    });
    // this.fetchSeasons();
    this.fetchUsers();
    this.fetchRoles();
    // this.calcSeasonDays();
    // this.populateBoardAndSupplement();
    // this.fetchBudget();
  },
};
</script>

<style scoped>
.form-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.card {
  padding: 15px;
  background: #fff;
  border-radius: 30px;
  border: 1px solid #ddd;
  position: relative;
}

.action-buttons {
  position: absolute;
  top: 100px;
  right: 10px;
}

hr {
  margin: 10px 0;
}

.modal-backdrop {
  opacity: 0.5 !important;
}


/* Aligning middle elements like Basic Board and Supplement */
.align-middle {
  margin-top: 30px;
  /* Adjust this value based on the spacing you want */
}

/* Custom shadow for room-card */
.shadow-custom {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
}

.shadow-custom:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 12px 40px rgba(0, 0, 0, 0.2);
}

.edit {
  position: absolute;

  top: 25%;
  /* Adjust the vertical position to be slightly above middle */
  right: -32px;
  transform: translateY(-160%);
  /* Center vertically relative to its position */

}

.save {
  position: absolute;
  top: 10%;
  /* Adjust as needed to lower the button */
  right: -32px;
  transform: translateY(-155%);
  /* Further adjust for desired position */
}

.delete {
  position: absolute;
  top: 30%;
  /* Adjust to position higher or lower */
  right: -32px;
  transform: translateY(-90%);
  /* Further adjust for desired position */

}

.custom-action-buttons {
  position: absolute;
  top: 40%;
  right: -32px;
  transform: translateY(-172%);
  background: #67B662;
  width: 40px;
  height: 40px;
}

.custom-action-buttons:hover {
  position: absolute;
  top: 40%;
  right: -32px;
  transform: translateY(-172%);
  background: #67B662;
  width: 40px;
  height: 40px;
}

.seasonality-pricing-container {
  padding: 20px;
}


.delete-button-seasons img {
  width: 30px;
  height: 30px;
}



.delete-button-seasons {
  position: absolute;
  background-color: #D03535;
  border-radius: 8px;
  top: 42px;
  right: -32px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.delete-button-seasons,
.delete-button-seasons:hover {
  background-color: #D03535;
}

.delete-button-seasons {
  position: absolute;
  top: 72%;
  /* Adjust to position higher or lower */
  right: -32px;
  transform: translateY(30%);
  /* Further adjust for desired position */

}

.edit-button-seasons img {
  width: 30px;
  height: 30px;
}

.edit-button-seasons {
  position: absolute;
  background-color: #67B662 !important;
  border-radius: 8px;
  top: 2px;
  right: -32px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transform: translateY(-160%);
  /* Further adjust for desired position */

}

.save-seasons {
  position: absolute;
  top: 40%;
  /* Adjust as needed to lower the button */
  right: -32px;
  transform: translateY(-90%);
  /* Further adjust for desired position */
}
</style>
